import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './index.scss';
import i18next from 'i18next';

const OtpInput = ({
	name,
	onChange,
	onBlur,
	value,
	invalid,
	error,
	disabled,
	control,
	apiErrors,
	label,
	id,
	className,
	outterRef,
	labelClassName,
	info,
	defaultValue,

	...props
}) => {
	const [otp, setOtp] = useState(['', '', '', '', '', '']);
	const inputRefs = useRef([]);
	const { t, i18n } = useTranslation();

	useEffect(() => {
		// putting the focus on the first input box on initial render
		inputRefs.current[0].focus();
	}, []);

	// For pasting the otp
	const handlePaste = e => {
		const pastedData = e.clipboardData.getData('text/plain');
		//check first if the pasted data length is 6
		if (pastedData.length !== 6) {
			return;
		}
		const otpArray = pastedData.split('');
		const newOtp = [...otp];
		otpArray.forEach((value, index) => {
			newOtp[index] = value;
		});
		setOtp(newOtp);
		const joinedOtp = newOtp.join('');
		const syntheticEvent = {
			target: {
				value: joinedOtp,
				name
			}
		};
		onChange(syntheticEvent);
		onBlur(syntheticEvent);
	};

	const handleInputChange = (index, event) => {
		const newOtp = [...otp];
		newOtp[index] = event.target.value;

		setOtp(newOtp);

		const joinedOtp = newOtp.join('');
		const syntheticEvent = {
			target: {
				value: joinedOtp,
				name
			}
		};
		onChange(syntheticEvent);
		onBlur(syntheticEvent);

		// Move to the next input box after typing
		if (event.target.value !== '' && index < 5) {
			inputRefs.current[index + 1].focus();
		}
	};

	const handleKeyDown = (index, event) => {
		if (event.key === 'Backspace' && index > 0 && otp[index] === '') {
			inputRefs.current[index - 1].focus();
		}
	};

	return (
		<>
			<div className={`py-2 mb-2 otp_wrapper ${i18next.language === 'ar' ? 'd-flex flex-row-reverse' : ''} `}>
				{otp.map((value, index) => (
					<input
						key={index}
						type='text'
						maxLength={1}
						value={value}
						className={`otp-input ${invalid ? `otp-input-invalid` : ``} `}
						onChange={e => handleInputChange(index, e)}
						// For pasting the otp
						onPaste={e => handlePaste(e)}
						onKeyDown={e => handleKeyDown(index, e)}
						ref={ref => (inputRefs.current[index] = ref)}
						onFocus={e => {
							e.target.style.borderColor = '#243d8c';
						}}
						onBlur={e => {
							e.target.style.borderColor = invalid ? '#8f220e' : '#ccc';
						}}
						onMouseEnter={e => {
							e.target.style.borderColor = '#243d8c';
						}}
						onMouseLeave={e => {
							e.target.style.borderColor = invalid ? '#8f220e' : '#ccc';
						}}
						disabled={disabled}
					/>
				))}
			</div>
			{error && error.message && <div className='invalid-feedback d-block'>{t(error.message)}</div>}
			{apiErrors && apiErrors[props.name] && (
				<div className='invalid-feedback d-block'>
					{apiErrors[props.name]?.map((apiError, index) => {
						return <p key={index}>{apiError}</p>;
					})}
				</div>
			)}
		</>
	);
};

export default OtpInput;
